import React from 'react';
import classnames from 'classnames';
import compact from 'lodash/compact';

import { NavigationItemComponentFragment } from '../../../graphql.schema';
import { NavigationLink } from '../NavigationLink/NavigationLink';
import StrapiLinkUnstyled from '../StrapiLink/StrapiLinkUnstyled';

import * as styles from './FooterNavigation.module.scss';

type Props = {
  items?: NavigationItemComponentFragment[];
};

export const FooterNavigation = ({ items }: Props) => {
  return (
    <nav className={classnames('footer-navigation', styles.root)}>
      {items?.map((item, idx) => (
        <ul key={`footerlinks-${idx}`}>
          {
            item.link ?
              <li key={`footerlinks-${idx}-${item.link.id}`}>
                <StrapiLinkUnstyled className={classnames('navbar-item is-text-2')} {...item.link}>
                  {item.link.title}
                </StrapiLinkUnstyled>
              </li> : null
          }
          {compact(item.childLinks).map((link) => (
            <li key={`footerlinks-${idx}-${link.id}`}>
              <NavigationLink link={link} />
            </li>
          ))}
        </ul>
      ))}
    </nav>
  );
};
